/*
 * UserList Messages
 *
 * This contains all the text for the UserList component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.RouteCreate.title',
    defaultMessage: 'Create Route',
  },
  saveButton: {
    id: 'app.containers.RouteCreate.saveButton',
    defaultMessage: 'Save',
  },
  saveSuccess: {
    id: 'app.containers.RouteCreate.saveSuccess',
    defaultMessage: 'Route has been successfully created.',
  },
  saveFailure: {
    id: 'app.containers.RouteCreate.saveFailure',
    defaultMessage: 'Error. The route could not be created.',
  },
});
